
import GenreMaker from '../echart/genreMaker';
import * as DataMaker from '../echart/echartData';


var BubbleChart = class BubbleChart extends GenreMaker {



  getChart(subGenre,data,theme){

    echarts.init(document.getElementById('container')).dispose();


    var option = new Object();
    option.chart = new Object();
    option.title={text:"图形预览",x:'center'};
    option.tooltip={ trigger: 'axis', showDelay : 0, axisPointer:{ show: true, type : 'cross', lineStyle: { type : 'dashed', width : 1 } } };

    option.xAxis=[{type : 'value',scale:true,axisLabel : {formatter: '{value}'}}];
    option.yAxis=[{type : 'value',scale:true,axisLabel : {formatter: '{value}'}}];

    var data = option;
    switch (subGenre) {
      case "bubble":
            option.series=[{name:'scatter1',type:'scatter',
                  symbolSize: function (value){
                      return Math.round(value[2] / 1);
                  },
                  data:  [[2000,1200,30], [2001,800,10], [2002,1100,30],
                  [2003,1500,20], [2004,921,40], [2005,1000,30], [2006,1400,20]]
              }
          ]




        data = option;
      break;

      case "doughnut":



        data = option;
      break;

      default:

    }




    switch(theme) {
      case "roma":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/roma')).setOption(data);
      break;
      case "sakura":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/sakura')).setOption(data);
      break;
      case "shine":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/shine')).setOption(data);
      break;
      case "default":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/default')).setOption(data);
      break;

      case "infographic":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/infographic')).setOption(data);
      break;

      case "macarons":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/macarons')).setOption(data);
      break;

      case "blue":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/blue')).setOption(data);
      break;

      case "dark":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/dark')).setOption(data);
      break;

      case "gray":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/gray')).setOption(data);
      break;

      case "green":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/green')).setOption(data);
      break;

      case "helianthus":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/helianthus')).setOption(data);
      break;

      case "mint":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/mint')).setOption(data);
      break;

      case "red":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/red')).setOption(data);
      break;
      default:
    }




        return echarts.init(document.getElementById('container'));
  }

}



GenreMaker.bubble = BubbleChart;

export var BubbleChart;



// WEBPACK FOOTER //
// ./src/echart/bubbleChart.js